/**
 * Refetches the mounted ones of the given profile tabs and requests their
 * counters once — from here, never from the tabs: a mounted tab skips its own
 * after-refetch counters request for this reload (`useReloadCountersAfterRefetch`),
 * and that request would be lost anyway when the tab unmounts or its list
 * request fails mid-way (`useAsyncCallback` promises never settle then). For
 * the same reason only the counters promise is returned.
 *
 * @param {Object} params
 * @param {Object<string, { handleReload: Function }>} params.registriesByTabId
 * @param {Function} params.reloadCounters receives the tab ids; the loaders
 *   that always request all the counters (Building, BuildingGroup, Flat)
 *   ignore them
 * @param {string[]} params.tabIds
 * @returns {Promise}
 */
export async function reloadRegistryTabsAndCounters({
  registriesByTabId,
  reloadCounters,
  tabIds,
}) {
  tabIds.forEach(tabId => {
    registriesByTabId[tabId]?.handleReload()
  })

  return reloadCounters(tabIds)
}
